import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { Alert, Button } from '@backstage/ui';
import { useEffect, useState } from 'react';

function UnlinkedIdentityBanner() {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);
  const [unlinked, setUnlinked] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { userEntityRef } = await identityApi.getBackstageIdentity();
      const entity = await catalogApi.getEntityByRef(userEntityRef);
      if (!cancelled && !entity) {
        setUnlinked(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [identityApi, catalogApi]);

  if (!unlinked || dismissed) {
    return null;
  }

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 2000 }}>
      <Alert
        status="warning"
        icon
        title="Unlinked identity"
        description={
          'You are signed in with a temporary identity that is not linked to a catalog user. ' +
          'Ownership and team features will not work. If you belong here, please create a ' +
          'tech-support ticket.'
        }
        customActions={
          <Button
            variant="tertiary"
            size="small"
            onPress={() => setDismissed(true)}
          >
            Dismiss
          </Button>
        }
      />
    </div>
  );
}

const unlinkedIdentityBanner = AppRootElementBlueprint.make({
  name: 'unlinked-identity-banner',
  params: {
    element: <UnlinkedIdentityBanner />,
  },
});

export const unlinkedIdentityBannerModule = createFrontendModule({
  pluginId: 'app',
  extensions: [unlinkedIdentityBanner],
});
